import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import CurrencyConverter from '../../CurrencyConverter/CurrencyConverter';

import messages from '../../../locale/messages';

import c from '../../SearchListing/ListingItem/ListingItem.css';
import s from '../../ViewListing/Calendar/Calendar.css';
class PriceDetails extends Component {
  render() {
    const { calculatedValues } = this.props;
    return (
      <div className={'priceDetailsTable'}>
        <table className={cx('table')}>
          <tbody>
            <tr className={s.positionR}>
              <td className={cx(s.noBorder, c.paddingTop)}>
                <div className={cx(s.specialPriceText, 'directionLtr')}>
                  <CurrencyConverter amount={calculatedValues?.isAverage} from={calculatedValues?.currency} />
                  {' x'} {calculatedValues?.dayDifference} {calculatedValues?.dayDifference > 1 ? <FormattedMessage {...messages.nights} /> : <FormattedMessage {...messages.night} />}
                </div>
              </td>
              <td className={cx(s.noBorder, 'text-right', 'textAlignLeftRtl', c.paddingTop)}>
                <CurrencyConverter amount={calculatedValues?.isDayTotal} from={calculatedValues?.currency} />
              </td>
            </tr>
            {calculatedValues?.discount > 0 && (
              <tr>
                <td className={cx(s.noBorder)}><FormattedMessage {...messages.discount} /></td>
                <td className={cx('text-right', s.discountText, s.noBorder, 'textAlignLeftRtl')}>
                  <span>- </span>
                  <CurrencyConverter amount={calculatedValues?.discount} from={calculatedValues?.currency} />
                </td>
              </tr>
            )}
            {calculatedValues?.extraGuestFeeAmount > 0 && (
              <tr>
                <td className={cx(s.noBorder)}>
                  {calculatedValues?.extraGuestCount} x <CurrencyConverter amount={calculatedValues?.extraGuestFeeAmount / calculatedValues?.extraGuestCount} from={calculatedValues?.currency} /> <FormattedMessage {...messages.extraGuestFee} />
                </td>
                <td className={cx('text-right', s.noBorder, 'textAlignLeftRtl')}>
                  <CurrencyConverter amount={calculatedValues?.extraGuestFeeAmount} from={calculatedValues?.currency} />
                </td>
              </tr>
            )}
            {calculatedValues?.cleaningPrice > 0 && (
              <tr>
                <td className={cx(s.noBorder)}><FormattedMessage {...messages.cleaningFee} /></td>
                <td className={cx('text-right', s.noBorder, 'textAlignLeftRtl')}>
                  <CurrencyConverter amount={calculatedValues?.cleaningPrice} from={calculatedValues?.currency} />
                </td>
              </tr>
            )}
            {calculatedValues?.serviceFee > 0 && (
              <tr>
                <td className={cx(s.noBorder)}><FormattedMessage {...messages.serviceFee} /></td>
                <td className={cx('text-right', s.noBorder, 'textAlignLeftRtl')}>
                  <CurrencyConverter amount={calculatedValues?.serviceFee} from={calculatedValues?.currency} />
                </td>
              </tr>
            )}
            <tr>
              <td className={cx(c.totalText)}><FormattedMessage {...messages.totalPriceModal} /></td>
              <td className={cx('text-right', c.totalText, 'textAlignLeftRtl')}>
                <CurrencyConverter amount={calculatedValues?.oneTotalPrice} from={calculatedValues?.currency} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

const mapState = (state) => ({
  totalpriceModal: state.modalStatus.isTotalPriceModal
});

export default withStyles(s, c)(connect(mapState)(PriceDetails));